/**
 * axios 응답 가로채기 네 곳(inapi·crm·call·counsel)이 같이 쓰는 새 오류 코드 처리(W6 E2).
 * 판정·문구는 순수 모듈 standardErrors.js, 여기는 알림·이동만.
 */
import { message } from "ant-design-vue";
import store from "@/store";
import { permissionDeniedText, standardErrorNotice } from "@/utils/standardErrors";

/**
 * responseType:'blob' 요청(내려받기)의 오류 본문은 blob 이라 code 를 못 읽는다 → JSON 이면 풀어 둔다.
 * 가로채기 맨 앞에서 불러야 step-up(MFA_REQUIRED)·새 코드 처리가 같이 된다.
 */
export async function decodeBlobError(error) {
  const data = error?.response?.data;
  if (typeof Blob === "undefined" || !(data instanceof Blob) || !/json/i.test(data.type || "")) return;
  try {
    error.response.data = JSON.parse(await data.text());
  } catch (e) {
    // JSON 이 아니면 그대로 둔다
  }
}

/**
 * 처리한 오류면 true(부르는 쪽은 토큰 갱신 없이 그대로 reject), 아니면 false.
 * @param notify false 면 알림을 띄우지 않는다(요청이 showErrorNotice:false — 화면이 직접 보임)
 */
export async function handleStandardError(error, { notify = true } = {}) {
  const n = standardErrorNotice(error, { labels: store.state.permLabels });
  if (!n) return false;
  // 권한 다시 읽기 요청 자신(introspect·perm-catalog)이 403 이면 또 부르지 않는다 — 진행 중인 읽기가 이 요청을 기다리므로 멈춤
  if (n.action === "RELOAD_PERMS" && !(error.config && error.config.skipPermReload)) {
    // 메뉴를 다시 그리도록 권한을 한 번만 다시 읽는다(순환 import 를 피해 늦게 불러옴)
    const { reloadPerms } = await import("@/api/standards");
    await reloadPerms();
    n.text = permissionDeniedText(n.required, store.state.permLabels);
  }
  if (n.action === "LOGOUT") {
    if (notify) message.error({ content: n.text, key: n.key });
    await store.dispatch("clearLocalStorage");
    if (window.location.pathname !== "/signin") window.location.href = "/signin";
    return true;
  }
  if (notify) message[n.level]({ content: n.text, key: n.key });
  return true;
}
